import type { SignupFormValues } from "@/lib/schemas/auth.schema"
import { apiClient, type AuthResponse, type AuthResponseEnvelope } from "@/lib/api/http"

export async function signupUser(data: SignupFormValues): Promise<AuthResponse> {
  // Backend returns the same envelope as sign-in:
  // { success, statusCode, message, data: { user, accessToken, refreshToken }, meta }
  const { data: envelope } = await apiClient.post<AuthResponseEnvelope>("/auth/sign-up/email", {
    email: data.email,
    password: data.password,
    name: data.name,
    accountType: "USER", // fixed value required by the backend
    role: data.role,     // "buyer" | "seller" from the form
  })

  // Unwrap the nested data envelope into a flat AuthResponse
  return {
    accessToken: envelope.data.accessToken,
    refreshToken: envelope.data.refreshToken,
    user: envelope.data.user,
  }
}
